import React, { useState, useImperativeHandle } from 'react';
import Slider from '@material-ui/core/Slider';
import { SelectArrow } from './Icons';

const RangeConnectionFilterValue = (props) => {

  const {
    filterTitle,
    filterName,
    filterOpen,
    handleFilter,
    valueBounds,
    setIndexValue,
    connectionFilterActive,
    setConnectionFilterActive,
    connectionBounds,
    connectionRangeRef,
  } = props;

  const handleChange = (event, newValue) => {
    setIndexValue(newValue);
    setConnectionFilterActive(true);
  };
  const valuetext = (value) => valueBounds[value];
  // const handleFilterEntry = () => setConnectionFilterActive(!connectionFilterActive);

  const [valueIndexValueGhost, setValueIndexValueGhost] = useState(valueBounds);

  const handleTemporaryDateChange = (event, newValue) => {
    setValueIndexValueGhost(newValue);
  };

  const resetIndexValueGhost = () => {
    setValueIndexValueGhost([0, connectionBounds[1]]);
  };

  useImperativeHandle(connectionRangeRef, () => {
    return {
      resetIndexValueGhost: resetIndexValueGhost
    };
  });

  const log10 = (x) => {
    return Math.log(x) / Math.log(10);
  }

  return (
    <div className={`filter-tab ${(filterOpen === filterName) ? 'expanded' : 'closed'}`}>
            <div className='filter-expander' id={filterName} onClick={(e) => handleFilter(e)}>
                <div>
                    <h2 className='color-invert'>{filterTitle}</h2>
                    <p className='color-invert'>
                        {
                            (valueIndexValueGhost[1] === valueBounds[1] && !connectionFilterActive) ? 'All Selected' : (
                                (!connectionFilterActive) ? 'Multiple Selections' : valueIndexValueGhost[0] + ' - ' + ((valueIndexValueGhost[1] === valueBounds[1]) ? valueIndexValueGhost[1] + '' : valueIndexValueGhost[1] + ''))
                        }
                    </p>
                </div>
                <SelectArrow className={(filterOpen === filterName) ? 'arrow' : 'arrow-spin-90'} />
            </div>


            <div className='range-container-wrapper'>
                <div className='range-values'>
                    <p className='color-invert'>{valueIndexValueGhost[0]}</p>
                    <p className='color-invert'>{(valueIndexValueGhost[1] === valueBounds[1]) ? valueIndexValueGhost[1] + '+' : valueIndexValueGhost[1] + ''} </p>
                </div>

                <div className='range-container'>
                    <Slider
                        min={0}
                        max={connectionBounds[1]}
                        step={1}
                        scale={x => log10(x)}
                        value={valueIndexValueGhost}
                        getAriaValueText={valuetext}
                        onChangeCommitted={handleChange}
                        onChange={handleTemporaryDateChange}
                        aria-labelledby="value-slider" />
                </div>

                {/* <div className='filter-select-all flex-container-left' onClick={() => handleFilterEntry()}>
                    {!connectionFilterActive && <TickMarkCircle className='inline-style' />}
                    {connectionFilterActive && <TickMarkBlankCircle className='inline-style' />}

                    <p className='color-invert inline-style'>Include Unspecified</p>
                </div> */}
            </div>
        </div>

  )
}

export default RangeConnectionFilterValue